const fromWindow = () =>
  typeof window !== "undefined" && window.__ENV__ ? window.__ENV__ : {};

const fromProcess = () => ({
  // CRA only exposes env vars prefixed with REACT_APP_
  API_URL: process.env.REACT_APP_API_URL,
  SHOW_UAT_BANNER: process.env.REACT_APP_SHOW_UAT_BANNER,
  CURRENT_VERSION: process.env.REACT_APP_CURRENT_VERSION,
  SERVER_LABEL: process.env.REACT_APP_SERVER_LABEL,
  CONNECTION_DEBUG: process.env.REACT_APP_CONNECTION_DEBUG,
  SECURITY_ENFORCE_PASSWORD_POLICY: process.env.REACT_APP_SECURITY_ENFORCE_PASSWORD_POLICY,
});

export const env = {
  ...fromProcess(), // dev (CRA dev server)
  ...fromWindow(),  // prod runtime (env.js)
};

export const API_URL = env.API_URL || "";
export const SHOW_UAT_BANNER = env.SHOW_UAT_BANNER || "false";
export const CURRENT_VERSION = env.CURRENT_VERSION || "0.0.0";
export const SERVER_LABEL = env.SERVER_LABEL || "local";
export const CONNECTION_DEBUG = env.CONNECTION_DEBUG || "false";
export const SECURITY_ENFORCE_PASSWORD_POLICY = env.SECURITY_ENFORCE_PASSWORD_POLICY || "false";